module.exports = __webpack_public_path__ + "img/600.fcb1839e.svg";